import { Link } from "react-router-dom";
import { routes } from "../../config/utilities/utils.constant";
import Captcha from "../Captcha";
import emailjs from "@emailjs/browser";
import { useRef, useState, useEffect } from "react";
import TurnstileWidget from "../TurnstileWidget";
import "./style.css";
import Turnstile from "react-turnstile";
import { useForm } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import NotificationBar from "../NotificationBar";
import { useNavigate } from "react-router-dom";
function ContactForm() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange", // enables real-time validation
  });
  const resetCaptchaRef = useRef(null);
  const siteKey = "0x4AAAAAABbgZGR1S_Q3Rgdb";
  const [token, setToken] = useState("");
  const [terms, setTerms] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const turnstileRef = useRef();
  const [error, setError] = useState(null);
  const formRef = useRef();
  const [turnstileState, setTurnstileState] = useState(false);
  const [retryCaptcha, setRetryCaptcha] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);
  const [openNotificationBar, setOpenNotificationBar] = useState(false);
const navigate = useNavigate();
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(0);
  const [userValue, setUserValue] = useState(0);
  const [isValueCorrect, setIsValueCorrect] = useState(true);
  useEffect(() => {
    setFirstValue(Math.floor(Math.random() * 9) + 1);
    setSecondValue(Math.floor(Math.random() * 9) + 1);
  }, []);

  const onSubmit = async (data) => {
    // data.preventDefault();
    //  console.log(data)

    // if (firstValue + secondValue === userValue) {
    //   setIsValueCorrect(true);
    // } else {
    //   setIsValueCorrect(false);
    //   return;
    // }

    setIsSubmittingForm(true);

    const formDataToSend = {
      full_name: data.full_name,
      email: data.email,
      contact: data.contact,
      company: data.company,
      project_details: data.project_details,
      request_nda: data.request_nda ? true : false,
      date: new Date().toLocaleString(),
    };
    // console.log(formDataToSend);

    try {
      const response = await fetch(
        "https://turnstile-validator.affan-8e4.workers.dev/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...formDataToSend }),
        }
      );
      if (!response.ok) {
        const text = await response.text(); 
        throw new Error(
          `Server error ${response.status}: ${text.slice(0, 100)}`
        );
      }
      let result;
      try {
        result = await response.json();
      } catch {
        const text = await response.text();
        throw new Error(`Invalid JSON response: ${text.slice(0, 100)}...`);
      }
      const { success, error } = result || {};

      if (!success) {
        setError(`Verification failed: ${error || "Unknown error"}`);
        setIsSubmittingForm(false);
        return;
      } else {
        // console.log(result)
        setError("");
        setOpenNotificationBar(true);
        formRef.current.reset();
        // Generate new math problem
        setFirstValue(Math.floor(Math.random() * 9) + 1);
        setSecondValue(Math.floor(Math.random() * 9) + 1);
        setUserValue(0);
        setTimeout(() => {
      navigate(routes.THANKSPAGE);  
        }, 1000);
 
      }
    } catch (err) {
      // console.error("Submission error:", err);
      setError(err.message || "Failed to submit data. Please try again.");
    } finally {
      setIsSubmittingForm(false);
      setError(null);
    }
  };

  // async function sendDataToWorker() {
  const handleRefreshExpireCaptcha = () => {
    setTurnstileState(true);
    setTimeout(() => {
      setTurnstileState(false);
      setRetryCaptcha(false);
    }, 2000);
  };

  return (
    <>
      <div className="md:w-3/5 rounded-lg shadow-[0_2px_20px_0_#00000012] px-5 md:px-10 pt-5 pb-10 bg-white space-y-5">
        <NotificationBar
          open={openNotificationBar}
          setOpen={setOpenNotificationBar}
        />

        <form
          ref={formRef}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          method="POST"
        >
          <div className="space-y-5">
            <div className="space-y-5 mt-4">
              <div>
                <input
                  type="text"
                  name="full_name"
                  id="full_name"
                  placeholder="Full Name *"
                  className="outline-none border-b w-full py-2 placeholder:text-gray-600"
                  {...register("full_name", {
                    required: "Full name is required",
                    validate: (value) => value.trim() !== "" || "Full name is required",
                  })}
                /> 
                {errors.full_name && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors.full_name.message}
                  </p>
                )}
              </div>
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Email *"
                  className="outline-none border-b w-full py-2 placeholder:text-gray-600"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Enter a valid email",
                    },
                  })}
                />
                {errors.email && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors.email.message}
                  </p>
                )}
              </div>
              <div>
                <label htmlFor="contact" className="sr-only">
                  Telephone Number
                </label>
                <input
                  type="text"
                  name="contact"
                  id="contact"
                  placeholder="Contact  *"
                  className="outline-none border-b w-full py-2 placeholder:text-gray-600"
                  {...register("contact", {
                    required: "Phone number is required",
                    minLength: {
                      value: 8,
                      message: "Phone number must be at least 8 digits",
                    },
                    maxLength: {
                      value: 15,
                      message: "Phone number must be at most 15 digits",
                    },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Phone number must contain only digits",
                    },
                  })}
                />
                {errors.contact && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors.contact.message}
                  </p>
                )}
              </div>
              <label htmlFor="company" className="sr-only">
                Company
              </label>
              <input
                name="company"
                id="company"
                type="text"
                {...register("company")}
                placeholder="Company "
                className="outline-none border-b w-full py-2 placeholder:text-gray-600"
              />
            </div>
            <div className="bg-gray-50">
              <label htmlFor="project_details" className="sr-only">
                Project Details
              </label>
              <textarea
                id="project_details"
                name="project_details"
                type="text"
                {...register("project_details")}
                rows={3}
                className=" w-full  placeholder:text-gray-600 px-3 py-4 placeholder:text-lg outline-none bg-gray-50 "
                placeholder="Tell us about your requirements/ideas "
              ></textarea>
            </div>
            <div className="space-y-4">
              <div className="flex items-center space-x-3 ">
                <input
                  type="checkbox"
                  id="request_nda"
                  name="request_nda"
                  className="cursor-pointer border-gray-600 w-[15px] h-[15px]"
                  {...register("request_nda")}
                  aria-label="Checkbox for requesting NDA"
                />
                <label htmlFor="request_nda" className="text-dark">
                  Send me an NDA
                </label>
              </div>
              <div>
                <div className="flex  space-x-3">
                  <div className=" pt-[1px]">
                    <input
                      type="checkbox"
                      id="terms"
                      className="cursor-pointer border-gray-600 w-[15px] h-[15px]"
                      {...register("terms", {
                        required: "Please check the box",
                      })}
                      aria-label="Checkbox for accepting consent to be contacted by SMS text message from Apptalyst"
                      name="terms"
                    />
                  </div>
                  <label htmlFor="terms" className="text-dark ">
                    By sharing your number and submitting the form you are
                    consenting to be contacted by SMS text message from
                    Apptalyst. Message & data rates may apply. Message frequency
                    may vary. Reply STOP to opt out of further messaging. Reply
                    Help to get help. Please refer to our{" "}
                    <Link
                      className="text-[#6D1349] underline "
                      to={routes.PRIVACYPOLICY}
                      aria-label="Internal link to privacy policy page"
                    >
                      privacy policy
                    </Link>{" "}
                    for more details.
                  </label>
                </div>

                {errors.terms && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors.terms.message}
                  </p>
                )}
              </div>
              <div>
                <div className="flex space-x-3 items-center"></div>

                <div role="group" aria-label="Math question">
                  <span
                     className="text-dark cursor-pointer select-none mr-1" 
                  >
                    I’m not a robot,{' '}
                  </span>
                  <span className="text-dark">{firstValue}</span>{" "}
                  <span className="text-dark" aria-hidden="true">
                    {" "}
                    +{" "}
                  </span>{" "}
                  <span className="text-dark"> {secondValue}</span>
                  <span className="text-dark" aria-hidden="true">
                    {" "}
                    ={" "}
                  </span>{" "}
                  <input
                    name="sumInput"
                    type="number"
                    className={`${
                     errors.challenge
                        ? " border-2 border-red-500"
                        : "border-2 border-gray-600"
                    } p-2 inline w-[4rem] outline-none   rounded-md no-arrows text-center`}
                    onChange={(e) => setUserValue(Number(e.target.value))}
                    aria-label={`Enter the sum of ${firstValue} and ${secondValue}`}
                    aria-describedby="mathInstruction"
                    {...register("challenge", {
                      required:
                        "Please solve the challenge  to confirm you're not a robot",
                         validate: (value) =>
      Number(value) === firstValue + secondValue ||
      "The answer is incorrect. Please try again.",
                    })}
                  />
                  <span id="mathInstruction" className="sr-only">
                    Provide your answer in numbers only
                  </span>
                </div>
                {errors.challenge && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors.challenge.message}
                  </p>
                )}
              
              </div>

              <div>
                {error && (
                  <p className="text-sm text-red-600 ">
                    Failed to submit the form. Please try again.
                  </p>
                )}
              </div>
            </div>
            <button
              className=" bg-[#FFC067] font-bold w-full rounded py-3 text-lg md:text-xl hover:bg-[#DF73FF]  transition ease-in duration-300 text-dark"
              type="submit"
              disabled={isSubmitting}
            >
              {" "}
              {isSubmitting ? (
                <CircularProgress color="dark" size="20px" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ContactForm;
